/* Copyright Information: Created by BuyGroup */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Spinner,
  CardBody,
  Button,
  Container,
  CardHeader,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import { CSVLink } from "react-csv";
import Breadcrumbs from "../components/common/breadcrumb";
import { Link } from "react-router-dom";
import ProductSlider from "../Products/ProductSlider";
import {
  groupDetail,
  deleteGroup,
  groupOrderList,
  removeOrderLineItem
} from "../services/GroupServices";
import { placeAmazonOrder } from "../services/OrderServices";
import Moment from "react-moment";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "./Group.css";
import DeleteOrderLineItem from "./DeleteOrderLineItem";

toast.configure();
const GroupDetails = (props) => {
  let role = JSON.parse(localStorage.getItem("role"));

  // this state is used for loading spinner
  const [isLoading, setLoading] = useState(false);

  //this state for group data
  const [groupData, setGroupData] = useState({});

  // this state for levels list array
  const [levels, setLevels] = useState([]);

  //current Date
  const currentDate = new Date();
  let tomorrow = new Date();
  tomorrow.setDate(currentDate.getDate() + 1);
  let formatTime = "MM/DD/YYYY h:mm a";
  let newCurrent = moment(currentDate, formatTime);
  let newstartdate = moment(new Date(groupData.start_date), formatTime);

  const [isLoadingButton, setIsLoadingButton] = useState(false);

  /* const "isDisableButton" is responsible for disable delete button */
  const [isDisableButton, setIsDisableButton] = useState(false);

  /* const "showDeleteAlert" responsible for open and closed  delete modal */
  const [showDeleteAlert, setshowDeleteAlert] = useState(false);

  /* const groupOrder  store order od group */

  const [groupOrder, setgroupOrder] = useState([]);

  const [ordersInGroup, setOrdersInGroup] = useState([]);

  const [deleteOrderLineItem, setDeleteOrderLineItem] = useState(false);
  const [customerOrderLineId, setCustomerOrderLineId] = useState(null);
  const [isLoadingRemoveOrderLineItem, setIsLoadingRemoveOrderLineItem] = useState(false);
  const [influencers, setInfluencers] = useState([]);
  const [showPlaceAmazonOrderModal, setShowPlaceAmazonOrderModal] = useState(false);
  const [isPlacingAmazonOrder, setIsPlacingAmazonOrder] = useState(false);
  const [amazonPlacementResult, setAmazonPlacementResult] = useState(null);

  /* it will fetch data from api */
  useEffect(() => {
    getGroupDetail();
    getGroupOrderDetail();
  }, []);
  //  this funciton is userd for group details
  const getGroupDetail = (silent = false) => {
    if (!silent) {
      setLoading(true);
    }
    return groupDetail(props.match.params.id)
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
          setGroupData(response.data);
          setLevels(response.data.levels || []);
          setShippingLevel(response.data.shipping_level || []);
          setOrdersInGroup(response.data.ordersInGroup || []);
          setInfluencers(response.data.influencers || []);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        if (!silent) {
          setLoading(false);
        }
      });
  };

  const getGroupOrderDetail = () => {
    return groupOrderList(props.match.params.id)
      .then((res) => {
        setgroupOrder(res.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const [shippingLevel, setShippingLevel] = useState([]);

  // this function remove group and call api s
  const removeGroup = () => {
    setIsDisableButton(true);
    deleteGroup(props.match.params.id)
      .then((response) => {
        if (response.status === 200) {
          setIsDisableButton(false);
          setshowDeleteAlert(false);

          toast.success(response.message, {
            autoClose: 3000,
            hideProgressBar: true,
          });
          props.history.push("/app/groups");
        }
      })
      .catch((error) => {
        setIsLoadingButton(false);
        toast.error(error.data.message, {
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
  };

  /* This Function will close delete Group modal */
  const onshowDeleteAlert = () => {
    setshowDeleteAlert(!showDeleteAlert);
  };
  const quantityFormatter = (cell, row, rowIndex) => (
    <div>
      <span>
        {rowIndex === 0
          ? 1 + " - " + cell
          : parseInt(levels[rowIndex - 1].quantity_level) + 1 + " - " + cell}
      </span>
    </div>
  );

  // Get status display name
  const getStatusDisplayName = (status) => {
    const statusNames = {
      in_progress: "In Progress",
      shipping: "To Be Shipped",
      completed: "Completed",
      cancelled: "Cancelled",
      paid: "Paid",
      payment_failed: "Payment Failed",
      return_requested: "Return Requested",
      return_accepted: "Return Accepted",
      return_declined: "Return Declined",
      return_in_progress: "Return In Progress",
      refunded: "Refunded",
      return_label_sent: "Return Label Sent",
      order_placed: "Order Placed",
      payment_captured: "Payment Captured",
      amazon_submit_pending: "Amazon Submit Pending",
      amazon_submitted: "Submitted to Amazon",
      amazon_submit_failed: "Amazon Submit Failed",
    };
    return statusNames[status] || status;
  };

  //    columns for bootstrap table
  const columns = [
    {
      dataField: "quantity_level",
      text: "Quantity",
      headerAlign: "right",
      align: "right",
      formatter: quantityFormatter,
    },
    {
      dataField: "discounted_price",
      text: "Price",

      headerAlign: "right",
      align: "right",
      formatter: (cell, row) => {
        return (
          <div className="category_name no-next-line">
            <span> {cell && "$" + parseFloat(cell).toFixed(2)}</span>
          </div>
        );
      },
    },
  ];
  const columnsShipping = [
    {
      dataField: "quantity_level",
      text: "Quantity",
      headerAlign: "right",
      align: "right",
      //  formatter: shippingQuantityFormatter,
      formatter: quantityFormatter,
    },
    {
      dataField: "shipping_price",
      text: "Shipping Cost $",
      headerAlign: "right",
      align: "right",
      formatter: (cell, row) => {
        return (
          <div className="category_name no-next-line">
            <span> {cell && "$ " + cell}</span>
          </div>
        );
      },
    },
  ];

  const headers = [
    { label: "Customer name", key: "customer_name" },
    { label: "quantity", key: "quantity" },
    { label: "street", key: "street" },
    { label: "City", key: "city" },
    { label: "State", key: "state" },
    { label: "Country", key: "country" },
    { label: "ZipCode", key: "zip_code" },
  ];

  const handleDeleteOrderLineItem = (cell) => {
    setCustomerOrderLineId(cell);
    setDeleteOrderLineItem(true);
  };

  const handleRemoveOrderLineItem = (orderLineId) => {
    console.log("removeOrderLineItem");
    setIsLoadingRemoveOrderLineItem(true);
    removeOrderLineItem(orderLineId)
      .then((res) => {
        toast.success(res.message, {
          autoClose: 3000,
          hideProgressBar: true,
        });
        setOrdersInGroup(ordersInGroup.filter(order => order.customer_order_line_id !== orderLineId));
      })
      .catch((err) => {
        console.error("err", err);
        toast.error(err.data.message, {
          autoClose: 3000,
          hideProgressBar: true,
        });
      })
      .finally(() => {
        setCustomerOrderLineId(null);
        setDeleteOrderLineItem(false);
        setIsLoadingRemoveOrderLineItem(false);
      });
  };

  const isTruthyValue = (value) => value === true || value === 1 || value === "1" || value === "true";

  const isAmazonOrderLine = (order) => {
    return order.amazon_product === true || order.amazon_product === "Yes" || order.is_amazon_product === true;
  };

  const isProcessedAmazonOrderLine = (order) => {
    return (
      order.amazon_order_id ||
      [
        "payment_failed",
        "payment_captured",
        "amazon_submit_pending",
        "amazon_submitted",
        "amazon_submit_failed",
        "refunded",
      ].includes(order.status)
    );
  };

  const amazonOrderPlacement = groupData.amazon_order_placement || {};
  const amazonPlacementApi =
    groupData.order_type ||
    amazonOrderPlacement.order_type ||
    "";
  const amazonPlacementApiLabel =
    amazonPlacementApi === "json"
      ? "JSON"
      : amazonPlacementApi === "cxml"
        ? "cXML"
        : "";
  const hasAmazonPlacementFlag = amazonOrderPlacement.can_place_order !== undefined;
  const isAdminRole = role && role[0] !== "SUPPLIER";
  const amazonOrderLines = ordersInGroup.filter(isAmazonOrderLine);
  const fallbackCanPlaceAmazonOrder =
    groupData.status === "Closed" &&
    amazonOrderLines.length > 0 &&
    !amazonOrderLines.some(isProcessedAmazonOrderLine);

  const canPlaceAmazonOrder =
    !isLoading &&
    isAdminRole &&
    (hasAmazonPlacementFlag
      ? isTruthyValue(amazonOrderPlacement.can_place_order)
      : fallbackCanPlaceAmazonOrder);

  const shouldShowAmazonPlacementControl =
    !isLoading &&
    isAdminRole &&
    (canPlaceAmazonOrder ||
      groupData.status === "Closed" ||
      isTruthyValue(amazonOrderPlacement.is_amazon_group) ||
      isTruthyValue(amazonOrderPlacement.is_closed_group));

  const amazonPlacementDisabledReason =
    amazonOrderPlacement.reason ||
    (!amazonOrderLines.length ? "This group does not have eligible Amazon order lines." : "");

  const closePlaceAmazonOrderModal = () => {
    if (!isPlacingAmazonOrder) {
      setShowPlaceAmazonOrderModal(false);
    }
  };

  const getAmazonPlacementMessage = (result) => {
    if (!result) {
      return null;
    }

    const fields = [
      ["payment_success_count", "Payment success count"],
      ["payment_failure_count", "Payment failure count"],
      ["submitted_line_count", "Submitted line count"],
      ["submitted_order_count", "Submitted order count"],
      ["amazon_status_code", "Amazon status code"],
      ["amazon_status_text", "Amazon status"],
      ["submission_id", "Submission ID"],
      ["payload_id", "Payload ID"],
      ["refund_count", "Refund count"],
      ["total_order_lines", "Total order lines"],
      ["eligible_order_lines", "Eligible order lines"],
      ["processed_order_lines", "Processed order lines"],
      ["failed_order_lines", "Failed order lines"],
      ["pending_order_lines", "Pending order lines"],
      ["submitted_order_lines", "Submitted order lines"],
    ];

    return fields
      .filter(([key]) => result[key] !== undefined && result[key] !== null && result[key] !== "")
      .map(([key, label]) => ({ label, value: result[key] }));
  };

  const handlePlaceAmazonOrder = () => {
    setIsPlacingAmazonOrder(true);
    setAmazonPlacementResult(null);

    placeAmazonOrder({ buy_group_id: props.match.params.id })
      .then((res) => {
        setAmazonPlacementResult(res);
        toast.success(res.message || "Amazon order placement started successfully", {
          autoClose: 3000,
          hideProgressBar: true,
        });
        getGroupDetail(true);
        getGroupOrderDetail();
      })
      .catch((error) => {
        const errorData =
          error?.response?.data ||
          error?.data ||
          {};
        setAmazonPlacementResult(errorData);
        toast.error(errorData.message || "Failed to place Amazon order", {
          autoClose: 3000,
          hideProgressBar: true,
        });
        getGroupDetail(true);
        getGroupOrderDetail();
      })
      .finally(() => {
        setShowPlaceAmazonOrderModal(false);
        setIsPlacingAmazonOrder(false);
      });
  };


  const actionFormatter = (cell, row) => (
    <div>
      <span
        className="inline-block pointer-cursor"
        onClick={() => handleDeleteOrderLineItem(cell)}
      >
        <i
          className="fa fa-trash"
          style={{
            width: 35,
            fontSize: 20,
            paddingLeft: 11,

            color: "#e4566e",
          }}
        ></i>
      </span>
    </div>
  );

  const columnsOrdersInGroup = [
    {
      dataField: "customer_name",
      text: "Customer Name",
    },
    {
      dataField: "parent_category",
      text: "Category",
    },
    {
      dataField: "influencer_name",
      text: "Influencer Name",
    },
    {
      dataField: "quantity",
      text: "Quantity",
    },
    {
      dataField: "totalAmount",
      text: "Total Amount",
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return <span>{getStatusDisplayName(cell)}</span>;
      },
    },
    {
      dataField: "amazon_product",
      text: "Amazon Product",
    },
    {
      dataField: "amazon_order_id",
      text: "Amazon Order ID",
    },
    {
      dataField: "address",
      text: "Address",
    },
    {
      dataField: "customer_order_line_id",
      text: "Action",
      formatter: (cell, row) => {
        return actionFormatter(cell, row);
      },
    },
  ];
  return (
    <>
      <Breadcrumbs title="Groups" parent="Groups" subtitle="Groups" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <div className="row align-items-center justify-content-between">
                  <div className="col-md-6">
                    <h5>View Group</h5>
                  </div>
                  <div className="col-md-6 text-right d-flex justify-content-end">
                    {!isLoading && groupOrder.length > 0 ? (
                      <div style={{ marginTop: "8px" }}>
                        <CSVLink
                          className="GroupOrder"
                          data={groupOrder}
                          headers={headers}
                          filename={"group.csv"}
                        >
                          Order CSV
                        </CSVLink>
                      </div>
                    ) : (
                      ""
                    )}

                    {!isLoading && role[0] !== "SUPPLIER" ? (
                      <div>
                        <Link
                          to={{
                            pathname: "/app/groups/" + props.match.params.id,
                          }}
                          className={
                            groupData.status == "Closed" ? "disable-link" : ""
                          }
                        >
                          <Button
                            type="button"
                            color="secondary"
                            data-toggle="modal"
                            disabled={groupData.status == "Closed"}
                          // disabled={moment(newCurrent).isAfter(newstartdate)}
                          >
                            <i className="fa fa-pencil mr-2"></i>
                            Edit
                          </Button>
                        </Link>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                {isLoading ? (
                  <div className="custom-loader">
                    <Spinner animation="border" />
                  </div>
                ) : (
                  <>
                    <Row className="product-adding">
                      <Col className="col-md-5">
                        <div className="clearfix">
                          <ProductSlider
                            sliderImages={groupData.productImage}
                            imageUrlKey="imageUrl"
                          />
                        </div>
                      </Col>
                      <Col className="col-md-7">
                        <h5>
                          <strong>{groupData.offer_name}</strong>
                        </h5>
                        <p>{groupData.description}</p>

                        <Row>
                          <Col md="4">
                            <div>
                              <h5>
                                <strong>Group ID </strong>
                              </h5>
                              <div className="clearfix product_detail_category">
                                <p>{groupData.group_id}</p>
                              </div>
                            </div>
                          </Col>
                          {role[0] !== "SUPPLIER" && (
                            <Col md="4">
                              <div>
                                <h5>
                                  <strong>Supplier Name </strong>
                                </h5>
                                <div className="clearfix product_detail_category">
                                  <p>{groupData.company_name}</p>
                                </div>
                              </div>
                            </Col>
                          )}
                          <Col md="4">
                            <div>
                              <h5>
                                <strong>Status</strong>
                              </h5>
                              <div className="clearfix product_detail_category">
                                <p>{groupData.status}</p>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div>
                              <h5>
                                <strong>Start Date </strong>
                              </h5>
                              <div className="clearfix product_detail_category">
                                <p>
                                  <Moment format="MM/DD/YYYY h:mm a">
                                    {groupData.start_date}
                                  </Moment>
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div>
                              <h5>
                                <strong>End Date</strong>
                              </h5>
                              <div className="clearfix product_detail_category">
                                <p>
                                  <Moment format="MM/DD/YYYY h:mm a">
                                    {groupData.end_date}
                                  </Moment>
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div>
                              <h5>
                                <strong>Min. Qty</strong>
                              </h5>
                              <div className="clearfix product_detail_category">
                                <p>{groupData.minimum_quantity}</p>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div>
                              <h5>
                                <strong>Total Order Placed</strong>
                              </h5>
                              <div className="clearfix product_detail_category">
                                <p>{groupData.quantity_booked}</p>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div>
                              <h5>
                                <strong>Total Participants</strong>
                              </h5>
                              <div className="clearfix product_detail_category">
                                <p>{groupData.number_of_participants}</p>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div>
                              <h5>
                                <strong>Zip Codes</strong>
                              </h5>
                              <div className="clearfix product_detail_category">
                                <p>{groupData.zip_code}</p>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div>
                              <h5>
                                <strong>Selling Price</strong>
                              </h5>
                              <div className="clearfix product_detail_category">
                                <p> $ {groupData.price}</p>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div>
                              <h5>
                                <strong>Current Product Price</strong>
                              </h5>
                              <div className="clearfix product_detail_category">
                                <p> $ {groupData.current_product_price}</p>
                              </div>
                            </div>
                          </Col>
                          {(isTruthyValue(groupData.is_amazon_product) ||
                            isTruthyValue(amazonOrderPlacement.is_amazon_group)) &&
                            amazonPlacementApiLabel && (
                            <Col md="4">
                              <div>
                                <h5>
                                  <strong>Order Type</strong>
                                </h5>
                                <div className="clearfix product_detail_category">
                                  <p>{amazonPlacementApiLabel}</p>
                                </div>
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          {levels.length > 0 && (
                            <Col md="6">
                              <div>
                                <h5>
                                  <strong>Quantity Range</strong>
                                </h5>

                                <BootstrapTable
                                  keyField="id"
                                  key={`quantityListTable`}
                                  striped
                                  hover
                                  condensed
                                  bordered={true}
                                  data={levels}
                                  columns={columns}
                                  rowClasses="row-hover"
                                />
                              </div>
                            </Col>
                          )}
                          {shippingLevel.length > 0 && (
                            <Col md="6">
                              <div>
                                <h5>
                                  <strong>Shipping Range</strong>
                                </h5>

                                <BootstrapTable
                                  keyField="id"
                                  key={`ShippingTable`}
                                  striped
                                  hover
                                  condensed
                                  bordered={true}
                                  data={shippingLevel}
                                  columns={columnsShipping}
                                  rowClasses="row-hover"
                                />
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col md="12">
                            <h5>
                              <strong>Influencers</strong>
                            </h5>
                            <div className="influencer-list">
                              <ul className="list-group">
                                {influencers.map((influencer) => (
                                  <li
                                    key={influencer.id}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                  >
                                    <div>
                                      <div className="font-weight-bold">
                                        {influencer.name}
                                      </div>
                                      {influencer.email ? (
                                        <small className="text-muted">
                                          {influencer.email}
                                        </small>
                                      ) : null}
                                    </div>
                                    <span className="badge badge-primary badge-pill">
                                      {influencer.influencer_code}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <Row className="align-items-center my-2">
                          <Col md="6">
                            <h5>
                              <strong>Orders in Group</strong>
                            </h5>
                          </Col>
                          <Col md="6" className="text-right">
                            {canPlaceAmazonOrder && (
                              <Button
                                color="primary"
                                onClick={() => setShowPlaceAmazonOrderModal(true)}
                                disabled={isPlacingAmazonOrder || !canPlaceAmazonOrder}
                                title={!canPlaceAmazonOrder ? amazonPlacementDisabledReason : ""}
                              >
                                {isPlacingAmazonOrder ? (
                                  <>
                                    <Spinner size="sm" /> Placing...
                                  </>
                                ) : (
                                  "Place Amazon Order"
                                )}
                              </Button>
                            )}
                          </Col>
                        </Row>
                        <BootstrapTable
                          keyField="customer_order_line_id"
                          key={`OrdersInGroupTable`}
                          data={ordersInGroup}
                          columns={columnsOrdersInGroup}
                          rowClasses="row-hover"
                          bordered={true}
                          hover={true}
                          striped={true}
                          condensed={true}
                          pagination={paginationFactory({
                            sizePerPage: 10,
                            showTotal: true,
                            hideSizePerPage: true,
                          })}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                <Modal
                  isOpen={showDeleteAlert}
                  style={{ overlay: { opacity: 0.1 } }}
                >
                  <ModalHeader toggle={onshowDeleteAlert}>
                    <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                      Delete Group
                    </h5>
                  </ModalHeader>
                  <ModalBody>
                    <p>Are you sure you want to delete this Group</p>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      type="submit"
                      color="primary"
                      onClick={removeGroup}
                      disabled={isDisableButton ? true : false}
                    >
                      {isDisableButton ? "Please Wait..." : "Yes, Delete it!"}
                    </Button>
                    <Button
                      type="button"
                      color="light"
                      onClick={onshowDeleteAlert}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>
                {deleteOrderLineItem && (
                  <DeleteOrderLineItem
                    customerOrderLineId={customerOrderLineId}
                    deleteOrderLineItem={deleteOrderLineItem}
                    closedDeleteModal={() => setDeleteOrderLineItem(false)}
                    removeOrderLineItem={handleRemoveOrderLineItem}
                    isLoadingRemoveOrderLineItem={isLoadingRemoveOrderLineItem}
                  />
                )}
                <Modal
                  isOpen={showPlaceAmazonOrderModal}
                  toggle={closePlaceAmazonOrderModal}
                  style={{ overlay: { opacity: 0.1 } }}
                >
                  <ModalHeader toggle={closePlaceAmazonOrderModal}>
                    <h5 className="modal-title f-w-600">Place Amazon Order</h5>
                  </ModalHeader>
                  <ModalBody>
                    <p>All eligible Amazon order lines in this closed group will be processed.</p>
                    {amazonOrderPlacement.eligible_order_lines !== undefined && (
                      <p>
                        <strong>Eligible lines:</strong> {amazonOrderPlacement.eligible_order_lines}
                      </p>
                    )}
                    {amazonPlacementApiLabel && (
                      <p>
                        <strong>Placement method:</strong> {amazonPlacementApiLabel}
                      </p>
                    )}
                    <ul>
                      <li>Payments will be captured first.</li>
                      <li>Lines with failed payments will be marked failed and skipped.</li>
                      <li>Successfully captured lines will be submitted to Amazon using this group's selected placement method.</li>
                      <li>If Amazon submission fails, captured Amazon payments will be refunded.</li>
                    </ul>
                    {amazonPlacementResult && getAmazonPlacementMessage(amazonPlacementResult)?.length > 0 && (
                      <div className="mt-3">
                        <h6>Last Result</h6>
                        <ul className="mb-0">
                          {getAmazonPlacementMessage(amazonPlacementResult).map((item) => (
                            <li key={item.label}>
                              <strong>{item.label}:</strong> {item.value}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      type="button"
                      color="primary"
                      onClick={handlePlaceAmazonOrder}
                      disabled={isPlacingAmazonOrder}
                    >
                      {isPlacingAmazonOrder ? (
                        <>
                          <Spinner size="sm" /> Please Wait...
                        </>
                      ) : (
                        "Yes, Place Order"
                      )}
                    </Button>
                    <Button
                      type="button"
                      color="light"
                      onClick={closePlaceAmazonOrderModal}
                      disabled={isPlacingAmazonOrder}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default GroupDetails;
/* Copyright Information: Created by BuyGroup */
